module.exports = __webpack_public_path__ + "static/media/unhappy.fcb2748b.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/unhappy.png
// module id = 1720
// module chunks = 0